import { Typography } from "@mui/material";
import { useMemo } from "react";

import NavGroup from "./NavGroup";
import { getUtilities } from "menu-items/utilities";

const MenuList = () => {
  const menuItems = useMemo(() => getUtilities(), []);

  return (
    <>
      {menuItems.map((item) => {
        switch (item.type) {
          case "group":
            return <NavGroup key={item.id} item={item} />;

          default:
            console.error("Invalid menu item:", item);
            return (
              <Typography key={item.id} variant="h6" color="error" align="center">
                Menu Items Error
              </Typography>
            );
        }
      })}
    </>
  );
};

export default MenuList;
